import { render, staticRenderFns } from "./chooseModules.vue?vue&type=template&id=5b04833c&scoped=true&"
import script from "./chooseModules.vue?vue&type=script&lang=js&"
export * from "./chooseModules.vue?vue&type=script&lang=js&"
import style0 from "./chooseModules.vue?vue&type=style&index=0&id=5b04833c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b04833c",
  null
  
)

export default component.exports